import * as React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import SnackbarAlert from '../common/SnackbarAlert';
import { MobileDatePicker, LocalizationProvider } from '@mui/lab';
import { LoadingButton } from '@mui/lab';
import request from '../../utils/request';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography, } from '@mui/material';

export default function UploadPolicyDoc({
  editData,
  closeModal,
  setShowSnackBarAlert
}) {

  const [loader, setLoader] = React.useState(null);


  const SUPPORTED_FORMATS = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];

  const validationSchema = Yup.object().shape({

    policyDocuement: Yup.mixed().required('Policy Document is required')
      .test(
        'Fichier taille',
        'File is too large (Max size: 5 MB)',
         (value) => !value || (value && value.size <= 5 * 1024 * 1024)
      )
      .test(
        'format',
        'Only accept image,pdf',
        (value) => !value || (value && SUPPORTED_FORMATS.includes(value.type))
      )
  });

  const formik = useFormik({
    initialValues: {
      orderId: '',
      policyDocuement: ''
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoader(true);
      const formData = new FormData();
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      };


      formData.append('policyDocuement', values.policyDocuement);
      formData.append('policyId', editData.policyId);
      formData.append('endorsementId', editData.id);
      await request.post('endorsement/reuploadPolicyDocument', formData, config)
        .then((data) => {
          setLoader(false);
          if (data.status) {
            setShowSnackBarAlert({
              status: true,
              type: 'success',
              message: 'Policy Details saved'
            });
            closeModal();
          } else {
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: data['message']
            });
          }
        })
        .catch(function (err) {
          console.log(err.message);
          setLoader(false);
        });
    }
  });

  const handleInvoiceAttachmentFile = async (event) => {
    formik.values.policyDocuement = event.target.files[0];
  };

  return (
    <div>

      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={true}
        onClose={() => closeModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Add Policy Details

        </DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <Grid container spacing={2} mt={0}>



              <Grid item xs={12}>
                <TextField
                  InputLabelProps={{
                    shrink: true
                  }}
                  label={
                    <React.Fragment>
                      Policy Document{' '}
                      <Typography component="span" sx={{ color: 'red' }}>
                        *
                      </Typography>
                    </React.Fragment>
                  }
                 
                  sx={{ width: '100%' }}
                  size="small"
                  type="file"
                  onChange={(event) => handleInvoiceAttachmentFile(event)}
                  error={
                    formik.touched.policyDocuement &&
                    Boolean(formik.errors.policyDocuement)
                  }
                  helperText={
                    formik.touched.policyDocuement &&
                    formik.errors.policyDocuement
                  }
                />
                <p>Supported Format: pdf,jpeg,png,jpg | Max upload file size 5MB</p>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => closeModal(false)} variant="contained" color='error'>Cancel</Button>
            <LoadingButton
              sx={{ mt: { xs: 2, md: 0 } }}
              loading={loader}
              variant="contained"
              type="submit"
            >
              Save
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
